import Styles from "./Styles.module.scss";
import { IndonesiaGlobe, mapicon } from "../../assets/png";
import iconTitleLocation from "../../assets/png/frame-title-location.png";
import closeIcon from "../../assets/png/close.png";
import { useNav } from "../../Hooks/useNav";
import { ArrowForward, Mail } from "@mui/icons-material";
import MdPhone from "@mui/icons-material/Phone";
import { useEffect, useMemo, useState } from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import Modal from "../../components/Modal";

export default function Benefit() {
  const aboutRef = useNav("About Us");
  const [isShowTooltip, setIsShowTooltip] = useState(false);

  const [isShowModal, setIsShowModal] = useState(false);
  const [showAnotherBranch, setShowAnotherBranch] = useState(0);

  const permataBranches = useMemo(() => {
    return [
      {
        id: 1,
        name: "Aceh",
        branches: ["Branch Office"],
        address: [
          "Jalan Kasaman No. 5 Desa Beurawe Kecamatan Kuta Alam Banda Aceh, Banda Aceh, 23127",
        ],
        phone: ["0651 - 7315783"],
        email: "info@pemataindonesia.com",
        right: "97.2%",
        top: "0%",
        link: "https://www.google.com/maps/place/Permata+Indonesia/@5.5411051,95.3308267,17z/data=!4m15!1m8!3m7!1s0x304037522e05b091:0xb7736beae31bbc6d!2sPermata+Indonesia!8m2!3d5.541093!4d95.3307498!10e5!16s%2Fg%2F11h_4s0trx!3m5!1s0x304037522e05b091:0xb7736beae31bbc6d!8m2!3d5.541093!4d95.3307498!16s%2Fg%2F11h_4s0trx?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: 2,
        name: "Medan",
        branches: ["Branch Office"],
        address: [
          "Jl. Nenas No.4c, Silalas, Kec. Medan Bar., Kota Medan, Sumatera Utara 20234",
        ],
        phone: ["061-4573367"],
        email: "info@pemataindonesia.com",
        right: "93.2%",
        top: "4.8%",
        link: "https://www.google.com/maps/place/PT.+Permata+Indonesia/@3.5994009,98.6670504,17z/data=!3m1!4b1!4m6!3m5!1s0x303131dd5e0b5135:0xf7ef9eb9c70526e0!8m2!3d3.5994009!4d98.6696253!16s%2Fg%2F11gbk130qx?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: 3,
        name: "Padang",
        branches: ["Branch Office"],
        address: [
          "48GW+9GH, Jl. Prof. Dr. Hamka, Parupuk Tabing, Kec. Koto Tangah, Kota Padang, Sumatera Barat 25586",
        ],
        phone: ["0751 - 8972602"],
        email: "info@pemataindonesia.com",
        right: "90.8%",
        top: "24.5%",
        link: "https://www.google.com/maps/place/Permata+Indonesia/@-0.874053,100.3437962,17z/data=!3m1!4b1!4m6!3m5!1s0x2fd4c0b5afc6e031:0x4427cec7f17829c3!8m2!3d-0.874053!4d100.3463711!16s%2Fg%2F11fr3xqj9r?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: 4,
        name: "Pekanbaru",
        branches: ["Branch Office"],
        address: [
          "Jl. Kutilang No.27B, Kp. Melayu, Kec. Sukajadi, Kota Pekanbaru, Riau 28122",
        ],
        phone: ["0761 - 7874395"],
        email: "info@pemataindonesia.com",
        right: "85.8%",
        top: "19%",
        link: "https://www.google.com/maps/place/PT.+PERMATA+INDONESIA/@0.5116359,101.4300659,17z/data=!3m1!4b1!4m6!3m5!1s0x31d5a9ea6c680311:0x6561bc572959258a!8m2!3d0.5116359!4d101.4326408!16s%2Fg%2F11lq1j17vb?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: 5,
        name: "Batam",
        branches: ["Branch Office"],
        address: [
          "43G2+8JM, Jl. Ahmad Yani, Tlk. Tering, Kec. Batam Kota, Kota Batam, Kepulauan Riau 29444",
        ],
        phone: ["0778 - 469875"],
        email: "info@pemataindonesia.com",
        right: "81.2%",
        top: "25.1%",
        link: "https://www.google.com/maps/place/Graha+Pena+Batam+Building/@1.1258311,104.0489696,17z/data=!3m1!4b1!4m6!3m5!1s0x31d9891dc75e6d49:0xdd4f3f4a69a931cb!8m2!3d1.1258311!4d104.0515445!16s%2Fg%2F1tdbt86p?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: "palembang",
        name: "Palembang",
        branches: ["Branch Office"],
        address: [
          "Komplek Ruko Pelangi (Ruko No. 12), Jl Sukabangun 1, Kel. Sukabangun Kec. Sukarami Palembang 30151",
        ],
        phone: ["0711 - 7443465"],
        email: "info@pemataindonesia.com",
        right: "81.5%",
        top: "45.6%",
        link: "https://www.google.com/maps/place/PT.+Permata+Indo+Sejahtera/@-2.9569523,104.7518369,16z/data=!4m10!1m2!2m1!1spermata+indonesia+palembang!3m6!1s0x2e3b75099911bf19:0x3b13bc124e91504c!8m2!3d-2.9568484!4d104.7518616!15sChtwZXJtYXRhIGluZG9uZXNpYSBwYWxlbWJhbmciA4gBAZIBEGNvcnBvcmF0ZV9vZmZpY2WqAWoKDS9nLzExaDZ5cnZiMnMQASoVIhFwZXJtYXRhIGluZG9uZXNpYSgmMh8QASIbCwyFtfzZt5HhWGtyOWVFbic6tkEEizInANEtMh8QAiIbcGVybWF0YSBpbmRvbmVzaWEgcGFsZW1iYW5n4AEA!16s%2Fg%2F11jbtx6wl0?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: "jambi",
        name: "Jambi",
        branches: ["Branch Office"],
        address: [
          "Jalan Kutilang IV No. 48 Tambak Sari Kecamatan Jambi, 36139",
        ],
        phone: ["-"],
        email: "info@pemataindonesia.com",
        right: "85%",
        top: "40%",
        link: "https://www.google.com/maps/place/Jl.+Kutilang+IV+No.48,+Tambak+Sari,+Kec.+Jambi+Sel.,+Kota+Jambi,+Jambi+36122/@-1.6127751,103.6240266,17z/data=!4m6!3m5!1s0x2e2588b9d1cfbe79:0xd0fdbf3a818e7cf6!8m2!3d-1.6128196!4d103.6240242!16s%2Fg%2F11lcnd8mfw?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: 7,
        name: "Lampung",
        branches: ["Branch Office"],
        address: [
          "JL. URIP SUMOHARJO LK I NO 166/23 RT/RW 003/000, KEC. WAYHALIM, KEL. GUNUNGSULAH KOTA. BANDAR LAMPUNG, KODE POS 35136",
        ],
        phone: ["0711 - 7443465"],
        email: "info@pemataindonesia.com",
        right: "80%",
        top: "58%",
        link: "https://www.google.com/maps/place/PT.+Permata+Indo+Sejahtera+Lampung/@-5.3890917,105.268266,17z/data=!3m1!4b1!4m6!3m5!1s0x2e40db1ccaec77fd:0x920187d755dfba3f!8m2!3d-5.3890917!4d105.2708409!16s%2Fg%2F11vm5qf442?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: 8,
        name: "Jakarta",
        branches: ["Head Office 1", "Head Office 2", "Head Office 3"],
        address: [
          "Jl. Kyai Maja No.7a, RT.4/RW.1, Grogol Sel., Kec. Kby. Baru, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12130",
          "Jl. Raya Kby. Lama No.225, RT.10/RW.1, Grogol Sel., Kec. Kby. Lama, Kota Jakarta Selatan, Daerah Khusus Ibukota Jakarta 12220",
          "Jalan Cidodol Raya No. 40, Kebayoran Baru, Jakarta Selatan, Kode Pos 12220, Indonesia",
        ],
        phone: ["021 726 5364 (Hunting)", "021 727 86574 (Fax)"],
        email: "info@pemataindonesia.com",
        right: "77%",
        top: "64.5%",
        link: [
          "https://www.google.com/maps/place/Permata+Indonesia/@-6.2421653,106.7888279,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f199e5f81647:0xe3b42b70ed3c41b2!8m2!3d-6.2421653!4d106.7914028!16s%2Fg%2F11rxp3jq7l?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
          "https://www.google.com/maps/place/Yamaha+Permata+Motor/@-6.2334513,106.7616884,15z/data=!4m10!1m2!2m1!1spermata+yamaha!3m6!1s0x2e69f6cfefd9f353:0x36f1d84d3035975c!8m2!3d-6.2334513!4d106.7807428!15sCg5wZXJtYXRhIHlhbWFoYSIDiAEBkgEWbW90b3JjeWNsZV9yZXBhaXJfc2hvcKoBjQEKDS9nLzExYmM2MnNiX2sKDS9nLzExYncyMXAyMmgKDC9nLzF5dzc1MHBfbQoJL20vMDFzdnJnCgkvbS8wMXgxczYQASoSIg5wZXJtYXRhIHlhbWFoYSgmMh8QASIbDa8EuKoz6uoD8xFlZWDXY2A29sqYq6ESGtt2MhIQAiIOcGVybWF0YSB5YW1haGHgAQA!16s%2Fg%2F11h0vttf4j?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
          "https://www.google.com/maps/@-6.2296472,106.7729898,3a,75y,192.86h,86.31t/data=!3m7!1e1!3m5!1shNzQxaJBAbJCBqNLZPvlGg!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fcb_client%3Dmaps_sv.tactile%26w%3D900%26h%3D600%26pitch%3D3.691282905458621%26panoid%3DhNzQxaJBAbJCBqNLZPvlGg%26yaw%3D192.85969635142396!7i16384!8i8192?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
        ],
      },
      {
        id: 9,
        name: "Bandung",
        branches: ["Branch Office"],
        address: [
          "Jl. Buah Batu No.232B, Cijagra, Kec. Lengkong, Kota Bandung, Jawa Barat 40264",
        ],
        phone: ["0222 730 4533"],
        email: "info@pemataindonesia.com",
        right: "73.5%",
        top: "69%",
        link: "https://www.google.com/maps/place/PT+Permata+Indo+Sejahtera/@-6.9424167,107.6250982,17z/data=!3m1!4b1!4m6!3m5!1s0x2e68e86313badaaf:0xc33282b8fbc76c47!8m2!3d-6.9424167!4d107.6276731!16s%2Fg%2F1hdz91tyn?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: 10,
        name: "Semarang",
        branches: ["Branch Office"],
        address: [
          "Jl. Pleburan Barat No.7 D, Pleburan, Kec. Semarang Sel., Kota Semarang, Jawa Tengah 50241",
        ],
        phone: ["024 845 6279"],
        email: "info@pemataindonesia.com",
        right: "69.5%",
        top: "68.6%",
        isCenter: true,
        link: "https://www.google.com/maps/place/Permata+Indonesia+Semarang/@-6.9972249,110.4219103,17z/data=!3m1!4b1!4m6!3m5!1s0x2e708b61b1847d7d:0x8d46cf050bebcb6c!8m2!3d-6.9972249!4d110.4244852!16s%2Fg%2F1hdzfvf26?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: 11,
        name: "Surabaya",
        branches: ["Branch Office"],
        address: [
          "Gedung Permata Indonesia, Jl. Kayoon No.26F, Embong Kaliasin, Kec. Genteng, Surabaya, Jawa Timur 60271",
        ],
        phone: ["031 5467541"],
        email: "info@pemataindonesia.com",
        right: "65.7%",
        top: "72%",
        isCenter: true,
        link: "https://www.google.com/maps/place/Permata+Indonesia/@-7.2680222,112.7454055,17z/data=!3m1!4b1!4m6!3m5!1s0x2dd7fbd85861ce13:0x10aa3fba95d209b3!8m2!3d-7.2680222!4d112.7479804!16s%2Fg%2F1hc2tc0x4?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },

      {
        id: 12,
        name: "Bali",
        branches: ["Branch Office"],
        address: [
          "Kompleks Pertokoan Sudirman Agung, C-49, Bali, Dauh Puri Klod, Denpasar Barat, Denpasar City, Bali 80113",
        ],
        phone: ["0361 241 687"],
        email: "info@pemataindonesia.com",
        right: "62%",
        top: "73.6%",
        isCenter: true,
        link: "https://www.google.com/maps/place/PT.PERMATA+INDO+SEJAHTERA+(PERMATA+INDONESIA)+BALI+NUSRA/@-8.6755313,115.2158067,17z/data=!3m2!4b1!5s0x2dd240e952bbb613:0x8da370543b27415c!4m6!3m5!1s0x2dd240eeb44b4e03:0xe8a194c3e6877f36!8m2!3d-8.6755313!4d115.2183816!16s%2Fg%2F1ptxlzcvb?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: 13,
        name: "Banjarmasin",
        branches: ["Branch Office"],
        address: [
          "70235, Jl. Karang Paci No.2, Karang Mekar, Kec. Banjarmasin Tim., Kota Banjarmasin, Kalimantan Selatan 70237",
        ],
        phone: ["0511-674 3316"],
        email: "info@pemataindonesia.com",
        right: "61%",
        top: "50%",
        isCenter: true,
        link: "https://www.google.com/maps/place/PT.PERMATA+INDO+SEJAHTERA,Tbk/@-3.3295565,114.6073711,17z/data=!3m1!4b1!4m6!3m5!1s0x2de423fd712f6fc7:0xb7026587375caae6!8m2!3d-3.3295565!4d114.609946!16s%2Fg%2F11dxfqmn_0?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },

      {
        id: 14,
        name: "Makassar",
        branches: ["Branch Office"],
        address: [
          "Kompleks Ruko Pasar Segar, Jl. Pengayoman Blok RD 5, Pandang, Kec. Panakkukang, Kota Makassar, Sulawesi Selatan 90231",
        ],
        phone: ["0411 - 433103"],
        email: "info@pemataindonesia.com",
        right: "50.5%",
        top: "60%",
        isCenter: true,
        link: "https://www.google.com/maps/place/PT.+Permata+Indo+Sejahtera+(Permata+Indonesia)/@-5.1622055,119.4466654,17z/data=!3m1!4b1!4m6!3m5!1s0x2dbefdaf8824386b:0x16ea47137f00d840!8m2!3d-5.1622055!4d119.4492403!16s%2Fg%2F11n__1mktk?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
      {
        id: 15,
        name: "Manado",
        branches: ["Branch Office"],
        address: [
          "Jl. Tni 8 Jl. Lingkungan 1 No.12A, Banjer, Kec. Tikala, Kota Manado, Sulawesi Utara 95124",
        ],
        phone: ["-"],
        email: "info@pemataindonesia.com",
        right: "43%",
        top: "25%",
        isCenter: true,
        link: "https://www.google.com/maps/place/PT.+Permata+Indo+Sejahtera+-+Cab.+Manado/@1.4802547,124.8479373,17z/data=!3m1!4b1!4m6!3m5!1s0x328775accbe10feb:0xebcda86de9b73c1d!8m2!3d1.4802547!4d124.8505122!16s%2Fg%2F11vrwvg4rs?entry=ttu&g_ep=EgoyMDI1MDcxMy4wIKXMDSoASAFQAw%3D%3D",
      },
    ];
  }, []);

  useEffect(() => {
    if (!isShowModal || !isShowTooltip) {
      setShowAnotherBranch(0);
    }
  }, [isShowModal, isShowTooltip]);

  const TooltipContent = ({ b }) => {
    return (
      <div
        key={b.id}
        className={`${Styles.pointBranch}  ${b.isHidden && Styles.erase}`}
        style={{
          right: b.right,
          top: b.top,
          height: b.id === "hidden-2" ? "24px" : "",
          width: b.id === "hidden-2" ? "24px" : "",
        }}
        onMouseEnter={() => (b.isHidden ? {} : setIsShowTooltip(b.id))}
        onMouseLeave={() => setIsShowTooltip(false)}
        onMouseUp={() => (b.isHidden ? {} : setIsShowTooltip(b.id))}
      >
        {b.id === isShowTooltip && <div className={Styles.keepHovering} />}
        <span className={Styles.pointed} />
        {b.id === isShowTooltip && (
          <div
            className={`${Styles.wrapTooltip}`}
            style={{
              left: b?.isCenter ? "-220px" : "-10px",
            }}
          >
            <span
              className={Styles.popover}
              style={{
                left: b?.isCenter ? "210px" : "",
              }}
            />
            <section className={Styles.tooltipContain}>
              <section className={Styles.header}>
                <div>
                  <img src={iconTitleLocation} alt="icon" />
                  <h5>Detail Lokasi</h5>
                </div>
                <img
                  src={closeIcon}
                  onClick={() => setIsShowTooltip(false)}
                  alt="close-icon"
                />
              </section>
              <div className={Styles.locationName}>
                <h5>{b.name}</h5>
                <span className={Styles.branch}>
                  {b.branches[showAnotherBranch]}
                </span>
                <div className={Styles.divider} />

                <div className={Styles.address}>
                  <div className={Styles.name}>
                    <img src={iconTitleLocation} alt="icon" />
                    <span
                      className={Styles.linkAddress}
                      onClick={() => {
                        if (b.name === "Jakarta")
                          window.open(b.link[showAnotherBranch], "_blank");
                        else window.open(b.link, "_blank");
                      }}
                    >
                      {b.address[showAnotherBranch]}
                    </span>
                  </div>
                  <div className={Styles.name}>
                    <MdPhone sx={{ color: "#6C757D" }} />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span className={Styles.values}>{b.phone[0]}</span>
                      <span className={Styles.values}>{b.phone[1]}</span>
                    </div>
                  </div>
                  <div className={Styles.name}>
                    <Mail sx={{ color: "#6C757D" }} />
                    <span className={Styles.values}>{b.email}</span>
                  </div>
                </div>
                {b.branches.length > 1 && (
                  <div className={Styles.buttonIcons}>
                    <div
                      onClick={() =>
                        showAnotherBranch === 0
                          ? {}
                          : setShowAnotherBranch(showAnotherBranch - 1)
                      }
                      className={Styles[showAnotherBranch !== 0]}
                    >
                      <ChevronLeft fontSize="24px" />
                    </div>
                    <div
                      onClick={() =>
                        showAnotherBranch === b.branches.length - 1
                          ? {}
                          : setShowAnotherBranch(showAnotherBranch + 1)
                      }
                      className={
                        Styles[showAnotherBranch === b.branches.length - 1]
                      }
                    >
                      <ChevronRight fontSize="24px" />
                    </div>
                  </div>
                )}
              </div>
            </section>
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <Modal isOpen={isShowModal} onClose={() => setIsShowModal(false)}>
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "300px",
          }}
        >
          {permataBranches
            .filter((el) => el.name === isShowModal)
            ?.map((b) => (
              <div
                key={b.id}
                className={`${Styles.pointBranch} ${
                  b.isHidden && Styles.erase
                }`}
                style={{
                  right: "98%",
                  top: "100%",
                  width: "0",
                  display: "flex",
                }}
              >
                <div className={Styles.wrapTooltip}>
                  <section className={Styles.tooltipContain}>
                    <section className={Styles.header}>
                      <div>
                        <img src={iconTitleLocation} alt="icon" />
                        <h5>Detail Lokasi</h5>
                      </div>
                      <img
                        src={closeIcon}
                        onClick={() => setIsShowModal(false)}
                        alt="close-icon"
                      />
                    </section>
                    <div className={Styles.locationName}>
                      <h5>{b.name}</h5>
                      <span className={Styles.branch}>
                        {b.branches[showAnotherBranch]}
                      </span>
                      <div className={Styles.divider} />

                      <div className={Styles.address}>
                        <div className={Styles.name}>
                          <img src={iconTitleLocation} alt="icon" />
                          <span
                            className={Styles.linkAddress}
                            onClick={() => {
                              if (b.name === "Jakarta")
                                window.open(
                                  b.link[showAnotherBranch],
                                  "_blank"
                                );
                              else window.open(b.link, "_blank");
                            }}
                          >
                            {b.address[showAnotherBranch]}
                          </span>
                        </div>
                        <div className={Styles.name}>
                          <MdPhone sx={{ color: "#6C757D" }} />
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <span className={Styles.values}>{b.phone[0]}</span>
                            <span className={Styles.values}>{b.phone[1]}</span>
                          </div>
                        </div>
                        <div className={Styles.name}>
                          <Mail sx={{ color: "#6C757D" }} />
                          <span className={Styles.values}>{b.email}</span>
                        </div>
                      </div>
                      {b.branches.length > 1 && (
                        <div className={Styles.buttonIcons}>
                          <div
                            onClick={() =>
                              showAnotherBranch === 0
                                ? {}
                                : setShowAnotherBranch(showAnotherBranch - 1)
                            }
                            className={Styles[showAnotherBranch !== 0]}
                          >
                            <ChevronLeft fontSize="24px" />
                          </div>
                          <div
                            onClick={() =>
                              showAnotherBranch === b.branches.length - 1
                                ? {}
                                : setShowAnotherBranch(showAnotherBranch + 1)
                            }
                            className={
                              Styles[
                                showAnotherBranch === b.branches.length - 1
                              ]
                            }
                          >
                            <ChevronRight fontSize="24px" />
                          </div>
                        </div>
                      )}
                    </div>
                  </section>
                </div>
              </div>
            ))}
        </div>
      </Modal>
      <div ref={aboutRef} id="About Us">
        <div className={Styles.Container}>
          <div className={Styles.left}>
            <div className={Styles.topLeft}>
              <div className={Styles.LeftMap}>
                <img src={mapicon} className={Styles.IconMap} alt="mapicon" />
              </div>
              <span className={Styles.spanYellow}>Our Company Location</span>
              <span className={Styles.spanH1}>
                Our Company is Spread Across Cities in Indonesia
              </span>
            </div>
            <div className={Styles.bottomLeft}>
              {permataBranches.map((el) => {
                return (
                  <div
                    key={el.id}
                    onClick={() => setIsShowModal(el.name)}
                    className={Styles.countries}
                  >
                    <span>{el.name}</span>
                    <ArrowForward
                      className={`${Styles.chevron}`}
                      sx={{ fontSize: "16px" }}
                    />
                  </div>
                );
              })}
            </div>
          </div>

          <div className={Styles.right}>
            <div className={Styles.globeParent}>
              <img src={IndonesiaGlobe} className={Styles.ImgMap} alt="globe" />

              {permataBranches.map((b) => (
                <TooltipContent b={b} />
              ))}
            </div>
          </div>
        </div>

        <div className={Styles.containerResponsive}>
          <div className={Styles.top}>
            <div className={Styles.companyLocationBox}>
              <div className={Styles.LeftMap}>
                <img src={mapicon} className={Styles.IconMap} alt="mapicon" />
              </div>
              <span className={Styles.spanYellow}>Our Company Location</span>
            </div>
            <span className={Styles.spanH1}>
              Our Company is Spread Across Cities in Indonesia
            </span>
          </div>

          <div className={Styles.imageMap}>
            <img
              src={IndonesiaGlobe}
              className={Styles.ImgMap}
              alt="IndonesiaGlobe"
            />
          </div>

          <div className={Styles.boxBottom}>
            <div className={`${Styles.bottom}`}>
              {permataBranches.map((el) => {
                return (
                  <div
                    key={el.id}
                    onClick={() => setIsShowModal(el.name)}
                    className={Styles.countries}
                  >
                    <span>{el.name}</span>
                    {el.name === isShowModal && (
                      <ArrowForward sx={{ fontSize: "16px" }} />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
